module.exports = __webpack_public_path__ + "img/ford.142ad9d0.svg";